// @ts-strict-ignore
import {
  Breadcrumb,
  init,
  reactRouterV5BrowserTracingIntegration,
  browserProfilingIntegration,
  getCurrentScope,
  addBreadcrumb,
  captureException,
  withSentryRouting
} from '@sentry/react';
import { ErrorWithUi } from 'errors';
import { History } from 'history';
import { Route as ReactRouterDomRoute } from 'react-router-dom';

import { SENTRY, API_HOST, VERSION } from 'constants/config';

export enum CustomSentryCategories {
  DEBUG = 'DEBUG'
}

export const initSentry = (history: History) => {
  init({
    ...SENTRY,
    release: `${VERSION}-${SENTRY.release}`,
    // uncomment to test sentry outgoing messages locally
    // beforeSend: (event: Sentry.Event) => {
    //   console.log(event);
    //   return null;
    // },
    ignoreErrors: ['User Unauthorized', 'No Internet Connection'], // todo: remove
    tracePropagationTargets: [API_HOST.replace(/https?:\/\//, '')],
    integrations: [
      reactRouterV5BrowserTracingIntegration({ history }),
      browserProfilingIntegration()
    ],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0
  });
};

export function setSentryUser(userId: number) {
  getCurrentScope().setUser({ id: String(userId) });
}

export function reportBreadcrumb(breadcrumb: Breadcrumb) {
  addBreadcrumb(breadcrumb);
}

export function reportError(err: Error | ErrorWithUi) {
  reportBreadcrumb({
    level: 'error',
    type: 'error',
    category: 'error',
    message: err.message,
    data: err
  });

  if (err instanceof ErrorWithUi) {
    err = convertToSentryError(err);
  }
  captureException(err);
}

export function convertToSentryError(error: ErrorWithUi): Error {
  const errorPrototype = Object.getPrototypeOf(error);
  const clone = Object.assign(Object.create(errorPrototype), { ...error });
  clone.stack = error.stack;
  //title is HIPPA compliant
  clone.message = error.ui.title;
  return clone;
}

export const Route = withSentryRouting(ReactRouterDomRoute);
